<template>
	<div>
		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0 card-list"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						cols="12"
						md="6"
						class="ml-auto"
					>
						<div class="d-flex">
							<b-form-input
								v-model="searchQuery"
								class="d-inline-block mr-1"
								placeholder="Buscar usuario ..."
								trim
							/>
							<b-button
								:to="{ name: 'users-create' }"
								variant="primary"
							>
								<span class="text-nowrap">Nuevo Usuario</span>
							</b-button>
						</div>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refUserListTable"
				class="position-relative table-providers"
				:style="'height: inherit'"
				:items="fetchUsers"
				responsive
				:fields="tableColumns"
				primary-key="id2"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<!-- <template #head(performance_group_name)="data">
					<span v-html="data.label"></span>
				</template>-->

				<template #cell(fullName)="data">
					<b-media vertical-align="center">
						<template #aside>
							<b-avatar
								size="32"
								:src="null"
								:text="avatarText(data.item.fullName)"
								variant="light-success"
							/>
						</template>
						{{ data.item.fullName }}
					</b-media>
				</template>

				<template #cell(status)="data">
					<div class="text-nowrap">
						<b-badge
							:variant="`light-${data.item.status ? 'success': 'danger'}`"
						>{{ data.item.status ? 'ACTIVO' : 'INACTIVO' }}</b-badge>
					</div>
				</template>

				<template #cell(actions)="data">
					<b-dropdown
						variant="link"
						no-caret
						:right="$store.state.appConfig.isRTL"
					>
						<template #button-content>
							<feather-icon
								icon="MoreVerticalIcon"
								size="16"
								class="align-middle text-body"
							/>
						</template>

						<b-dropdown-item :to="{ name: 'users-edit', params: { id: data.item.id } }">
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Editar</span>
						</b-dropdown-item>

						<b-dropdown-item @click="sendCredentials(data.item.id)">
							<feather-icon icon="MailIcon" />
							<span class="align-middle ml-50">Enviar Credenciales</span>
						</b-dropdown-item>

						<b-dropdown-item @click="changeUserStatus(data.item.id)">
							<feather-icon icon="UserCheckIcon" />
							<span class="align-middle ml-50">Cambiar Estado</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalUsers"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import useNotifications from "@notifications"
import { formatStringToDate } from "@core/utils/filter"
import { ref, onUnmounted } from "@vue/composition-api"
import userStoreModule from "../userStoreModule"
import useUsersList from "./useUsersList"
import { avatarText } from "@core/utils/filter"
import VueSweetalert2 from "vue-sweetalert2"
import vSelect from "vue-select"
import store from "@/store"
import Vue from "vue"
import "animate.css"

Vue.use(VueSweetalert2)

export default {
	components: {
		vSelect
	},
	setup() {
		// USE TOAST
		const { swalNotification } = useNotifications()

		// REFS
		const options = ref({})

		const USER_APP_STORE_MODULE_NAME = "app-user"

		// REGISTER MODULE
		if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
			store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(USER_APP_STORE_MODULE_NAME))
				store.unregisterModule(USER_APP_STORE_MODULE_NAME)
		})

		const changeUserStatus = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de modificar el estado actual?",
				text: "¡Si no lo está, puede cancelar la acción!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, modificar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-user/changeUserStatus", { id })
						.then((response) => {
							refetchData()
							swalNotification(response.data.message)
						})
						.catch((error) => {
							const message =
								error.response.data.message ||
								"Error al cambiar de estado del usuario"
							swalNotification(message, false)
						})
				}
			})
		}

		const sendCredentials = (id) => {
			store
				.dispatch("app-user/sendUserCredentials", { id })
				.then((response) => {
					swalNotification(response.data.message)
				})
				.catch((error) => {
					const message =
						error.response.data.message ||
						"Error al enviar las creedenciales al postor."
					swalNotification(message, false)
				})
		}

		const {
			fetchUsers,
			tableColumns,
			perPage,
			currentPage,
			totalUsers,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refUserListTable,
			refetchData
		} = useUsersList()

		return {
			fetchUsers,
			tableColumns,
			options,
			perPage,
			currentPage,
			totalUsers,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refUserListTable,
			refetchData,

			// ACTIONS
			avatarText,
			changeUserStatus,
			sendCredentials,

			formatStringToDate
		}
	}
}
</script>

<style lang="scss" scoped>
.media {
	align-items: center;
}

.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>